export type GhlConnection = {
  id: string;
  ghl_location_id: string;
  company_name: string;
  webhook_url: string | null;
  is_active: boolean;
  last_synced_at: string | null;
};

export type GhlPipeline = {
  id: string;
  ghl_connection_id: string;
  ghl_pipeline_id: string;
  pipeline_name: string;
  location_id: string | null;
  product_type: string | null;
  is_active: boolean;
};

export type LocationOption = {
  id: string;
  name: string;
};

export type SyncResult = {
  synced: number;
  connections: number;
  results: Array<{
    connection: string;
    pipeline: string;
    synced: number;
    stagesFound?: number;
    error?: string;
  }>;
};

export type GhlAvailPipeline = { id: string; name: string };

export const blankConn = {
  company_name: "",
  ghl_location_id: "",
  ghl_api_key: "",
  webhook_url: "",
};

export type GhlNewConnectionDraft = typeof blankConn;

export const blankPipe = {
  ghl_pipeline_id: "",
  pipeline_name: "",
  location_id: "",
  product_type: "",
};

export type GhlNewPipelineDraft = typeof blankPipe;

export function fmtDate(iso: string | null) {
  if (!iso) return "Never";
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
